import { FC, ReactNode } from 'react'
import { Box } from '@mui/material'
import Dialog from '@mui/material/Dialog'
import type { SxProps, Theme } from '@mui/material/styles'
import Image from 'next/image'

import styles from './modal.module.scss'
export interface ModalProps {
	open: boolean
	onClose: (e?: any) => void
	children?: ReactNode
	/** Доп. стили для Paper — например minWidth на десктопе */
	paperSx?: SxProps<Theme>
	/** Растянуть диалог по ширине (по умолчанию фиксированная ширина 408px у корневого sx) */
	wide?: boolean
}
export const Modal: FC<ModalProps> = ({ open, onClose, children, paperSx, wide = false }) => {
	return (
		<Dialog
			className={styles.modal}
			sx={
				wide
					? { margin: '0 auto', textAlign: 'center', width: '100%', maxWidth: '100vw' }
					: {
							width: '408px',
							margin: '0 auto',
							textAlign: 'center',
					  }
			}
			PaperProps={{
				style: {
					borderRadius: 20,
				},
				sx: [{ backgroundColor: '#373737' }, ...(paperSx ? [paperSx] : [])] as SxProps<Theme>,
			}}
			open={open}
			onClose={onClose}
		>
			<Image onClick={onClose} className={styles.close} src={'/x-mark.svg'} width={14} height={14} alt={''} />
			<Box className={styles.wrap}>{children}</Box>
		</Dialog>
	)
}
